module.exports = __webpack_public_path__ + "static/media/Bicocca - white_PW Pink.64aafb91.jpg";